import BaseModelAPI from '../BaseModelAPI';

export default class DocumentCategory extends BaseModelAPI {
	static entity = 'documentcategory';
	static entityName = 'documentcategory';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}